/**
 * Work List Animations
 */

document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    // ─── Project List Reveal ───────────────────────────────────────────────

    const workItems = document.querySelectorAll('.work-item');

    workItems.forEach((item) => {
        gsap.from(item, {
            y: 40,
            opacity: 0,
            duration: 1.2,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: item,
                start: 'top 90%',
                toggleActions: 'play none none reverse',
            },
        });
    });

    // Headline Reveal
    gsap.from('.work-hero__headline', {
        y: 40,
        opacity: 0,
        duration: 1.5,
        ease: 'power4.out',
        delay: 0.2,
    });
});
